import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, IconButton, Stack } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@mui/icons-material/Close";
import FullyRoundedButton from "../buttons/FullyRoundedButton";
import Colors from "../../../global/Colors";

const DragAndDropContainer = ({ initValue, onValueChange }) => {
  const [selectedFile, setSelectedFile] = useState(initValue);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setSelectedFile(initValue);
  }, [initValue]);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      setSelectedFile(file);
      onValueChange(e, file); 
    }
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      onValueChange(e, file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  const handleCancel = (e) => {
    setSelectedFile(null);
    onValueChange(e, null);
  };

  return (
    <Box
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      sx={{
        border: "2px dashed grey",
        padding: "20px",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: isDragging ? Colors.gray[300] : Colors.gray[100],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "auto",
        position: 'relative',
      }}
    >
      {selectedFile ? (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="subtitle1">{selectedFile.name}</Typography>
          <IconButton onClick={handleCancel} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      ) : (
        <div className="flex flex-col items-center justify-center space-y-2">
          <CloudUploadIcon className="text-3xl text-gray-600" />
          <Typography variant="subtitle1">
            Drag and drop a file here or
          </Typography>
          <FullyRoundedButton
            buttonText="Browse"
            variant="outlined"
            horizontalMargin="mx-0"
            bgColor="bg-white"
            hoverBgColor={Colors.blue[100]}
            textColor="text-blue-600"
            hoverTextColor="text-blue-600"
            borderWidth="border-[1px]"
            hoverBorderWidth="border-[1px]"
            borderColor="border-blue-600"
            handleOnClick={triggerFileInput}
          />
          <input
            ref={fileInputRef}
            type="file"
            hidden
            onChange={(event) => handleChange(event)}
            style={{position:'absolute', top: '0', right: '0', left: '0', bottom:'0'}}
            className="h-full w-full m-0"
          />
        </div>
      )}
    </Box>
  );
};

export default DragAndDropContainer;
